import { useToast } from "./toast-context";

const typeStyle = {
  success: {
    border: "border-green-600",
    bg: "bg-green-50",
    icon: "bi-check-circle text-green-600",
  },
  error: {
    border: "border-red-600",
    bg: "bg-red-50",
    icon: "bi-exclamation-circle text-red-600",
  },
  warning: {
    border: "border-yellow-600",
    bg: "bg-yellow-50",
    icon: "bi-exclamation-triangle text-yellow-600",
  },
  info: {
    border: "border-blue-600",
    bg: "bg-blue-50",
    icon: "bi-info-circle text-blue-600",
  },
};

export function ToastItem({ toast }) {
  const { dismiss, _pause, _resume } = useToast();
  const style = typeStyle[toast.type] ?? typeStyle.success;

  const lines = String(toast.message || "").split("\n");

  return (
    <div
      role="status"
      aria-live="polite"
      onMouseEnter={() => _pause(toast.id)}
      onMouseLeave={() => _resume(toast.id)}
      className={`pointer-events-auto flex items-center justify-between p-4 rounded-lg border ${style.border} ${style.bg} shadow-md transition
                  animate-[fadeIn_.2s_ease-out]`}
      style={{ animationFillMode: "both" }}
    >
      <div className="flex items-center">
        <span className="flex-shrink-0 mr-3">
          <i className={`bi ${style.icon} text-xl leading-none`} />
        </span>
        <p className="text-gray-800 font-body-primary text-sm">
          {lines.map((ln, i) => (
            <span key={i}>
              {ln}
              {i !== lines.length - 1 && <br />}
            </span>
          ))}
        </p>
      </div>

      {toast.closable && (
        <button
          onClick={() => dismiss(toast.id)}
          className="ml-4 text-gray-500 hover:text-gray-700 focus:outline-none"
          aria-label="Close"
        >
          <i className="bi bi-x-lg" />
        </button>
      )}
    </div>
  );
}
